import { getLoggedInUser } from 'public/users.js'
import wixLocation from 'wix-location';
import { triggerEvent } from 'public/bi-logger.js';
let emailClicked = 0;
import wixAnimations from 'wix-animations';
const arrow01 = wixAnimations.timeline ({ repeat: -1, yoyo: true, repeatDelay: 3000} )

$w.onReady(function () {

arrow01
.add($w('#mainarrow01'),{ scale: 1, y: 0, x: 19, duration: 800, rotate: 0, opacity: 1, easing:'easeInOutQuad' })
.add($w('#mainarrow01'),{ scale: 1, y: 0, x: 0, duration: 800, rotate: 0, opacity: 1, easing:'easeInOutQuad' })
.play()

    $w('#signUpButton').onClick(async () => {
        signUpHandler();
    })

    $w('#input1').onFocus(async () => {
        await triggerEvent('lp', 19, 718, 'app_url=wix.com');
        $w('#input1').placeholder = "Enter your email address";
    });

    $w('#input1').onBlur(() => {
        if (!$w('#input1').value) {
            $w('#input1').placeholder = "Enter your email address";
        }
    });
    $w('#input1').onKeyPress(async (e) => {
        if (emailClicked === 0) {
            emailClicked = 1;
            if ($w('#input1').value !== null) {
                await triggerEvent('lp', 19, 719, 'app_url=wix.com');
            }
        }
        if (e.key === 'Enter') {
            signUpHandler();
        }
    })

});

async function signUpHandler() {
    const email = $w('#input1').value;
    await triggerEvent('lp', 19, 720, 'app_url=wix.com&validEmail=' + validateEmail($w('#input1').value));
    const success = await getLoggedInUser();
    console.log(success, "here is success")
    if (success) {
        wixLocation.to('https://www.wix.com/account/sites');
    } else {
        wixLocation.to(`https://users.wix.com/signin?loginDialogContext=signup&defaultEmail=${email}`);
    }
}

function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}